import DataTable from "../components/DataTable";
import { StoreState } from "../types";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "./../actions";
import { dataLoaded, dataRequested } from "../actions/ui";
import { receiveResultsFailure } from "../actions/results";

export function mapStateToProps({ columns, query }: StoreState.All) {
  return {
    displayFields: query.fixedDisplayFields.concat(query.displayFields),
    columns: columns,
    aggReport: query.aggReport,
    apiUrl: query.urls.apiJson,
  };
}

export function mapDispatchToProps(
  dispatch: Dispatch<actions.AllActions>,
  ownProps: any,
) {
  return {
    onStartRequest: () => {
      dispatch(dataRequested());
    },
    onResultSuccess: () => dispatch(dataLoaded()),
    onResultFailure: (error: any) => dispatch(receiveResultsFailure(error)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataTable);
